export const getTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  const minutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(minutes / 60);

  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} m ago`;
  if (hours < 24) return `${hours} h ${minutes % 60} m ago`;

  const days = Math.floor(hours / 24);
  return `${days}d ${hours % 24}h ago`;
};
